import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconChevronsUp",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.646 2.646a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 1 1-.708.708L6 3.707 3.854 5.854a.5.5 0 1 1-.708-.708l2.5-2.5Z",
  "clip-rule": "evenodd"
}, null, -1), u = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.646 6.146a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 1 1-.708.708L6 7.207 3.854 9.354a.5.5 0 1 1-.708-.708l2.5-2.5Z",
  "clip-rule": "evenodd"
}, null, -1), p = [
  _,
  u
];
function h(a, m, l, f, v, e) {
  return d(), i("svg", {
    "aria-label": l.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--chevrons-up"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Chevrons Up",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, p, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", h]]);
export {
  I as default
};
//# sourceMappingURL=chevrons-up.js.map
